<template>

    <div id="accept-invitation">
        <img class="logo" alt="Lewis Rice" src="../assets/images/lewis-rice-logo-white.svg">
        <h1>Estate Planning Document Portal</h1>
        <div v-if="checkComplete">
            <h2>Welcome!</h2>
            <p>It looks like this is your first time here.<br>Let's complete your account setup.</p>
            <button class="btn btn-lg btn-default" @click="goSetPassword()">Continue</button>
        </div>
    </div>

</template>



<script>

    import router from '@/router'
    import UserService from '@/services/user.service'
    import UserInvitationsService from '@/services/user-invitations.service'

    export default {

        name: 'accept-invitation',

        data() {
            return {
                checkComplete: false,
                invitation: {}
            }
        },

        computed: {
        	token: function() { return this.$route.query.token; },
        	invitationId: function() { return this.$route.query.id; }
        },

        created: function() {
            UserService.logout()
                .then(this.getInvitation)
        },

        methods: {

        	getInvitation: function() {
        		UserInvitationsService.getInvitationWithToken(this.invitationId, this.token)
        			.then(use.bind(this))
                    .catch(failure.bind(this))
                    .finally(cleanup.bind(this))

        		function use(invitation) {
                    this.invitation = invitation
        			if (invitation.user.isVerified) router.push('/')
        			return invitation
        		}

                function failure(xhr) {
                    if (xhr.status >= 400) router.push('/')
                }

                function cleanup() {
                    this.checkComplete = true
                }

        	},

            goSetPassword() {
                router.push('/password-reset?token=' + this.token + '&username=' + encodeURIComponent(this.invitation.user.email) + '&newaccount')
            }
        }
    }

</script>



<style lang="scss" scoped>

    @import "../variables";

    #accept-invitation {

        color: #fff;

        .logo {
            display: inline-block;
            margin: 2rem 0 0 0;
            width: 70%;
            height: auto;
            max-width: 400px;
        }

        h1 {
            text-transform: uppercase;
            font-size: 1.2rem;
            letter-spacing: 0.3em;
            color: #999;
            line-height: 1.2;
            font-weight: 300;
            margin: 2rem 0 3rem 0;
        }

        button {
            margin-top: 2rem;
            text-transform: uppercase;
            letter-spacing: 0.1em;
        }
    }

</style>



// WEBPACK FOOTER //
// AcceptInvitation.vue?34bc6b24